// 고객 알림 액션(rpc) — 설정 알림 탭의 끄는 사건 저장.
import { rpc } from "@/api/client";

export const saveCustomerNotifyOff = (input: unknown) => rpc("customer-notify/actions/saveCustomerNotifyOff", input);
